import _defineProperty from "/vercel/path1/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { CheckIcon } from '@chakra-ui/icons';
import { Container, Flex, Heading, Icon, SimpleGrid, Stack, StackDivider, Text, useColorModeValue } from '@chakra-ui/react';
import Image from 'next/image';
import screenshot from '../../../public/landing/product_screen.png';
var FEATURES = ['Automatically update new articles', 'Unlimited articles and publishers', 'Advanced publications search', 'Beautiful design', 'Subscribers mailing list'];

var Feature = function Feature(_ref) {
  var text = _ref.text,
      icon = _ref.icon,
      iconBg = _ref.iconBg;
  return /*#__PURE__*/_jsxs(Stack, {
    direction: 'row',
    align: 'center',
    children: [/*#__PURE__*/_jsx(Flex, {
      w: 8,
      h: 8,
      align: 'center',
      justify: 'center',
      rounded: 'full',
      bg: iconBg,
      children: icon
    }), /*#__PURE__*/_jsx(Text, {
      fontWeight: 600,
      children: text
    })]
  });
};

export default function SplitWithImage() {
  return /*#__PURE__*/_jsx(Container, {
    maxW: '5xl',
    py: 12,
    children: /*#__PURE__*/_jsxs(SimpleGrid, {
      columns: {
        base: 1,
        md: 2
      },
      spacing: 10,
      children: [/*#__PURE__*/_jsxs(Stack, {
        spacing: 4,
        children: [/*#__PURE__*/_jsx(Heading, {
          fontWeight: 900,
          children: "Everything you need for a Publication Hub"
        }), /*#__PURE__*/_jsxs(Text, {
          color: "gray.700",
          fontSize: 'lg',
          children: ["We've learned dozens of publication and faculty pages, to create everything needed for top end ", /*#__PURE__*/_jsx(Text, {
            as: "span",
            fontWeight: "bold",
            color: "primaryPurple.500",
            children: "Publication Hub"
          }), "."]
        }), /*#__PURE__*/_jsx(Stack, {
          spacing: 4,
          divider: /*#__PURE__*/_jsx(StackDivider, {
            borderColor: useColorModeValue('gray.100', 'gray.700')
          }),
          children: FEATURES.map(function (f) {
            return /*#__PURE__*/_jsx(Feature, {
              icon: /*#__PURE__*/_jsx(Icon, {
                as: CheckIcon,
                color: 'green.500',
                w: 5,
                h: 5
              }),
              text: f
            }, f);
          })
        })]
      }), /*#__PURE__*/_jsx(Flex, {
        children: /*#__PURE__*/_jsx(Image, _objectSpread({
          alt: 'feature image'
        }, screenshot))
      })]
    })
  });
}